import { useQuery } from '@tanstack/react-query';
import { fetchSidebarData } from '../services/sidebarService';

export function useSidebarData() {
  return useQuery({
    queryKey: ['sidebarData'],
    queryFn: fetchSidebarData,
    staleTime: 3 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: null,
  });
}
